<template>
  <v-alert :type="alertType" :border="alertType === 'info' ? 'right' : 'bottom'" colored-border prominent>
    <v-row justify="center">
      <span class="title">{{ message }}</span>
      <v-icon v-if="alertType === 'error'" class="ml-2" large>
        sentiment_very_dissatisfied
      </v-icon>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "AppAlert",
  props: {
    alertType: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  }
}
</script>
